import { useMutation } from '@tanstack/react-query';

import { useAuthStore } from '../auth.store';
import type { LoginRequest, LoginResponse } from '../auth.types';

/**
 * Hook de mutação pra fluxo de login. Componente chama `mutate(creds)` —
 * `isPending`/`error` saem direto da return. Em sucesso, atualiza o store
 * de auth (que dispara navegação no guard).
 */
export function useLogin() {
  const login = useAuthStore((s) => s.login);
  return useMutation<LoginResponse, unknown, LoginRequest>({
    mutationFn: (req) => login(req),
  });
}
